import { Injectable } from "@angular/core";
import { Actions, Effect, ofType } from "@ngrx/effects";
import { catchError, map, switchMap } from "rxjs/operators";
import { Observable, of } from "rxjs";
import { KwikspaceService } from 'src/app/services/kwikspace.service';
import { CreateDiscountedTransportPriceFailure, CreateDiscountedTransportPriceSuccess, GetDiscountedTransportPriceFailure, GetDiscountedTransportPriceSuccess, GetTransportAreasFailure, GetTransportAreasSuccess, GetTransportDistrictsFailure, GetTransportDistrictsSuccess, GetTransportLoadsFailure, GetTransportLoadsSuccess, GetTransportOptionsFailure, GetTransportOptionsSuccess, GetTransportPriceFailure, GetTransportPriceListFailure, GetTransportPriceListSuccess, GetTransportPriceSuccess, TransportActionTypes, UpdateDiscountedTransportPriceFailure, UpdateDiscountedTransportPriceSuccess } from "../actions/transport.action";

@Injectable()
export class TransportEffects {
  public constructor(
    private actions$: Actions,
    private service: KwikspaceService
  ) { }

  @Effect()
  GetTransportChargeOptions$: Observable<any> = this.actions$.pipe(
    ofType(TransportActionTypes.GET_TRANSPORT_OPTIONS),
    switchMap((action: any) => {
      return this.service.getTransportChargeOptions().pipe(
        map((res: any) => new GetTransportOptionsSuccess(res)),
        catchError((error) => of(new GetTransportOptionsFailure(error)))
      );
    })
  );

  @Effect()
  GetTransportLoads$: Observable<any> = this.actions$.pipe(
    ofType(TransportActionTypes.GET_TRANSPORT_LOADS),
    switchMap((action: any) => {
      return this.service.getTransportChargeLoad().pipe(
        map((res: any) => new GetTransportLoadsSuccess(res)),
        catchError((error) => of(new GetTransportLoadsFailure(error)))
      );
    })
  );

  // @Effect()
  // GetTransportLoadsPurchase$: Observable<any> = this.actions$.pipe(
  //   ofType(TransportActionTypes.GET_TRANSPORT_LOADS_PURCHASE),
  //   switchMap((action: any) => {
      // return this.service.getTransportChargeLoadPurchase().pipe(
  //       map((res: any) => new GetTransportLoadsPurchaseSuccess(res)),
  //       catchError((error) => of(new GetTransportLoadsPurchaseFailure(error)))
  //     );
  //   })
  // );

  @Effect()
  GetTransportAreas$: Observable<any> = this.actions$.pipe(
    ofType(TransportActionTypes.GET_TRANSPORT_AREAS),
    switchMap((action: any) => {
      return this.service.getTransportAreas(action.payload).pipe(
        map((res: any) => new GetTransportAreasSuccess(res)),
        catchError((error) => of(new GetTransportAreasFailure(error)))
      );
    })
  );

  @Effect()
  GetTransportDistricts$: Observable<any> = this.actions$.pipe(
    ofType(TransportActionTypes.GET_TRANSPORT_DISTRICTS),
    switchMap((action: any) => {
      return this.service.getTransportDistricts(action.payload).pipe(
        map((res: any) => new GetTransportDistrictsSuccess(res)),
        catchError((error) => of(new GetTransportDistrictsFailure(error)))
      );
    })
  );

  @Effect()
  GetTransportChargeList$: Observable<any> = this.actions$.pipe(
    ofType(TransportActionTypes.GET_TRANSPORT_PRICE_LIST),
    switchMap((action: any) => {
      return this.service.getTransportChargeConfig(action.payload).pipe(
        map((res: any) => new GetTransportPriceListSuccess(res)),
        catchError((error) => of(new GetTransportPriceListFailure(error)))
      );
    })
  );

  @Effect()
  GetTransportPrice$: Observable<any> = this.actions$.pipe(
    ofType(TransportActionTypes.GET_TRANSPORT_PRICE),
    switchMap((action: any) => {
      return this.service.getTransportChargeList(action.payload).pipe(
        map((res: any) => new GetTransportPriceSuccess(res)),
        catchError((error) => of(new GetTransportPriceFailure(error)))
      );
    })
  );

  @Effect()
  GetDiscountedTransportPrice$: Observable<any> = this.actions$.pipe(
    ofType(TransportActionTypes.GET_DISCOUNTED_TRANSPORT_PRICE),
    switchMap((action: any) => {
      return this.service.getDiscountedTransportChargeList(action.payload).pipe(
        map((res: any) => new GetDiscountedTransportPriceSuccess(res)),
        catchError((error) => of(new GetDiscountedTransportPriceFailure(error)))
      );
    })
  );

  @Effect()
  CreateDiscountedTransportPrice$: Observable<any> = this.actions$.pipe(
    ofType(TransportActionTypes.CREATE_DISCOUNTED_TRANSPORT_PRICE),
    switchMap((action: any) => {
      return this.service.createDiscountedTransportCharge(action.payload).pipe(
        map((res: any) => new CreateDiscountedTransportPriceSuccess(res)),
        catchError((error) => of(new CreateDiscountedTransportPriceFailure(error)))
      );
    })
  );

  @Effect()
  UpdateDiscountedTransportPrice$: Observable<any> = this.actions$.pipe(
    ofType(TransportActionTypes.UPDATE_DISCOUNTED_TRANSPORT_PRICE),
    switchMap((action: any) => {
      return this.service.updateDiscountedTransportCharge(action.payload, action.id).pipe(
        map((res: any) => new UpdateDiscountedTransportPriceSuccess(res)),
        catchError((error) => of(new UpdateDiscountedTransportPriceFailure(error)))
      );
    })
  );

}
